import type { LocationSelectParentOptionProps } from "./location-select-parent-option.type";

import { Select, Tooltip } from "antd";

import { getLocationSelectParentOptionItem } from "./location-select-parent-option.helper";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const LocationSelectParentOption = ({
  option,
}: LocationSelectParentOptionProps) => {
  const { value, label, truncatedLabel } =
    getLocationSelectParentOptionItem(option);
  return (
    <Option key={value} value={value}>
      <Tooltip title={label}>{truncatedLabel}</Tooltip>
    </Option>
  );
};

export default LocationSelectParentOption;
